// extracted by mini-css-extract-plugin
export default {"wrapper":"TurnAround_wrapper__wrVzQ","container":"TurnAround_container__qjVuC","pCenter":"TurnAround_pCenter__ragwt"};